import { ROUTES } from "~/Routes";
import type { PermissionKey } from "~/types/Permissions";
import type { NavGroup } from "~/types/Routes";

export type MainNavSubmenuItem = {
  title: string;
  route: string;
  href?: string;
  permissions?: PermissionKey[];
};

export type MainNavItem = {
  title: string;
  route: string;
  permissions?: PermissionKey[];
  submenu?: MainNavSubmenuItem[];
};

const GROUP_ORDER: NavGroup[] = [
  "accounting",
  "dealers",
  "staff",
  "analytics",
  "information",
  "settings",
];

export function buildMainNav(): MainNavItem[] {
  const groups = new Map<
    NavGroup,
    {
      groupTitle: string;
      items: {
        title: string;
        route: string;
        href?: string;
        permissions?: PermissionKey[];
        order: number;
      }[];
    }
  >();

  for (const route of ROUTES) {
    if (!route.nav) continue;
    const { group, groupTitle, title, order = 0 } = route.nav;

    if (!groups.has(group)) {
      groups.set(group, { groupTitle: groupTitle ?? group, items: [] });
    }
    const g = groups.get(group)!;
    if (groupTitle) g.groupTitle = groupTitle;
    g.items.push({
      title,
      route: route.path,
      permissions: route.permissions,
      order,
    });
  }

  groups.get("dealers")?.items.push({
    title: "headerMenu.dealers_sub_BecomeCandidate",
    route: "/auth",
    href: "/auth",
    permissions: ["dealer.candidate"],
    order: 0,
  });

  return GROUP_ORDER.filter((key) => groups.has(key)).map((key) => {
    const g = groups.get(key)!;
    const sorted = g.items.sort((a, b) => a.order - b.order);
    return {
      title: g.groupTitle,
      route: sorted[0]?.route ?? "/",
      submenu: sorted.map(({ title, route, href, permissions }) => ({
        title,
        route,
        href,
        permissions,
      })),
    };
  });
}

export const mainNav: MainNavItem[] = buildMainNav();
